<template>
	<IconButtonLayout
		class="calendar-button"
		ref="calendarActivator"
		:disabled="disabled"
		@click="onClick"
	>
		<template #default="{ iconClass }">
			<FontAwesomeIcon
				:title="title"
				:class="iconClass"
				:icon="[ `far`, `calendar-range`]"
			/>
			<OverlayPanel
				ref="calendarOverlay"
			>
				<div>
					<Calendar
						:disabled="disabled"
						:modelValue="value"
						:inline="true"
						@date-select="onChange"
						@hide="onHide"
					/>
				</div>
			</OverlayPanel>
		</template>
	</IconButtonLayout>
</template>

<script>
import IconButtonLayout from "./IconButtonLayout.vue";

export default {
	name: "CalendarButton",
	teamingPackage: "common-ui",
	emits: [ "change", ],
	components: {
		IconButtonLayout,
	},
	props: {
		title: {
			type: String,
			default: "",
		},
		value: {
			type: [ Date, String, ],
			default: undefined,
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},
	methods: {
		onClick( event ) {
			this.$refs.calendarOverlay.toggle( event );
		},
		/**
		 * @param {Date} date - the (JS) date selected
		 */
		onChange( date ) {
			this.$emit( "change", date );
			this.$refs.calendarOverlay.hide();
		},
		onHide() {
			this.$refs.calendarOverlay.hide();
		},
	},
};
</script>

<style lang="scss" scoped>
.calendar-button {
	position: relative;
}
</style>
